import React, { Component } from "react";
import PropTypes from "prop-types";

class LoaderTekstWithTimeout extends Component {
    constructor(props) {
        super(props);

        this.timer = null;

        this.state = {
            hidden: true
        };
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ hidden: false });
        }, this.props.wait);
    }

    componentWillUnmount() {
        if (this.timer)
            clearTimeout(this.timer);
    }

    render() {
        if (this.state.hidden)
            return null;

        return (
            <div style={{ backgroundColor: "white", color: "black" }}>
                <br /><br />
                {this.props.children}
                <br /><br /><br />
            </div>
        );
    }
}

LoaderTekstWithTimeout.propTypes = {
    wait: PropTypes.number,
    children: PropTypes.node
};

LoaderTekstWithTimeout.defaultProps = {
    wait: 500
};

export default LoaderTekstWithTimeout;
